import { ApiProperty } from "@nestjs/swagger";

export class DrrRequest{
    @ApiProperty()
    date:any;
    @ApiProperty()
    divisionId?: number;
    @ApiProperty()
    clientCode?: string;
    // constructor(date:Date,divisionId?: number,clientCode?: string){
    //     this.date=date;
    //     this.clientCode=clientCode;
    //     this.divisionId=divisionId
    // }
}